import { render, staticRenderFns } from "./AnchorBarLink.vue?vue&type=template&id=bf65413a&"
import script from "./AnchorBarLink.vue?vue&type=script&lang=js&"
export * from "./AnchorBarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports